import React from 'react'
import DoctorBooking from '../../components/DoctorBooking/DoctorBooking'

export default function DoctorBookingPage() {
  return (
    <DoctorBooking/>
  )
}
